import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-clear-history-dialog',
  templateUrl: './clear-history-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ClearHistoryDialog {
  constructor(
    public dialogRef: MatDialogRef<ClearHistoryDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}
}
